import React from 'react';
import { makePrioStyles } from '../../../theme/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Flex from '../../../components/Flex';
import { Skeleton } from './MailListSkeleton';
import { useTheme } from '@prio365/prio365-react-library';
import { PrioTheme } from '../../../theme/types';
import { useSelector } from 'react-redux';
import { getMailSettings } from '../../../apps/main/rootReducer';

const useStyles = makePrioStyles((theme) => ({
  icon: {
    overflow: 'hidden',
    height: '16px',
    width: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

interface MailMenuSkeletonProps {}

export const MailMenuSkeleton: React.FC<MailMenuSkeletonProps> = (
  props: MailMenuSkeletonProps
) => {
  const classes = useStyles();
  const theme = useTheme<PrioTheme>();
  const mailSettings = useSelector(getMailSettings);

  const padding =
    mailSettings.mailListSpacing === 'tight'
      ? '2px 12px'
      : mailSettings.mailListSpacing === 'middle'
        ? '4px 16px'
        : '8px 24px';

  const skeletonHeight =
    mailSettings.mailListSpacing === 'tight'
      ? '12px'
      : mailSettings.mailListSpacing === 'middle'
        ? '14px'
        : '16px';

  return (
    <div>
      {Array(4)
        .fill(null)
        .map((_, index) => (
          <Flex.Row
            key={index}
            width="100%"
            padding={padding}
            childrenGap={theme.spacing.regular}
            alignItems="center"
          >
            <Flex.Item>
              <Skeleton isCircle />
            </Flex.Item>
            <Flex.Item flex={1} height={skeletonHeight}>
              <Skeleton />
            </Flex.Item>
            <Flex.Item className={classes.icon}>
              <FontAwesomeIcon
                icon={['fal', 'ellipsis-v']}
                color={'rgb(0, 0, 0, 0.2)'}
              />
            </Flex.Item>
            <Flex.Item className={classes.icon}>
              <FontAwesomeIcon
                icon={['fal', 'chevron-down']}
                color={'rgb(0, 0, 0, 0.2)'}
              />
            </Flex.Item>
          </Flex.Row>
        ))}
    </div>
  );
};

export default MailMenuSkeleton;
